module.exports = __webpack_public_path__ + "img/roll7.76715f23.png";